// Multilingual content (IT / EN / DE / FR / AR / ES)
export const LANGS = [
  { code: 'it', label: 'IT', name: 'Italiano', dir: 'ltr' },
  { code: 'en', label: 'EN', name: 'English', dir: 'ltr' },
  { code: 'de', label: 'DE', name: 'Deutsch', dir: 'ltr' },
  { code: 'fr', label: 'FR', name: 'Français', dir: 'ltr' },
  { code: 'es', label: 'ES', name: 'Español', dir: 'ltr' },
  { code: 'ar', label: 'AR', name: 'العربية', dir: 'rtl' },
];

export const translations = {
  it: {
    nav: { home: 'Home', catalog: 'Collezione', about: 'Chi Siamo', locations: 'Sedi', sell: 'Vendi il tuo Orologio', partners: 'Partner', contact: 'Contatti', admin: 'Admin' },
    home: {
      our_selection: 'La Nostra Selezione',
      eyebrow: 'Maison di alta orologeria',
      title_1: 'Timeless',
      title_2: 'by Nature',
      subtitle: 'Compravendita di orologi di lusso, brokeraggio privato e network internazionale tra Dubai, Svizzera e Monte Carlo.',
      cta_explore: 'Scopri la collezione',
      cta_sell: 'Vendi il tuo orologio',
      featured: 'Pezzi in evidenza',
      vision_eyebrow: 'La nostra visione',
      vision_title: 'Un network premium. Clienti selezionati.',
      vision_body: 'GN Watches non si limita al proprio stock: opera come watch broker per partner visionari, offrendo varietà, flessibilità e accesso a opportunità esclusive in tutto il mondo.',
      model_eyebrow: 'Il nostro modello',
      model_title: 'Asset-light. Curato. Discreto.',
      model_body: 'I nostri clienti accedono sia agli orologi disponibili presso GN Watches, sia a una rete selezionata di pezzi dei nostri partner.',
      why_eyebrow: 'Perché GN Watches',
      why_items: ['Sourcing internazionale', 'Accesso off-market', 'Client screening', 'Private brokerage', 'Riservatezza assoluta', 'Network consolidato'],
      where_eyebrow: 'Dove operiamo',
      where_title: 'Dubai · Svizzera · Monte Carlo',
      where_body: 'Un network consolidato di buyer e seller, con l\'ambizione di espanderci globalmente.',
      hub_hq: 'Quartier Generale', hub_me: 'Hub Medio Oriente', hub_eu: 'Hub Europeo',
      stat_hubs: 'Hub Globali', stat_pieces: 'Off-Market Pieces', stat_valuation: 'Valutazione',
      featured_eyebrow: 'In evidenza', featured_title: 'Selezione attuale', featured_cta: 'Vedi tutto',
      featured_empty: 'Nuovi pezzi in arrivo a breve. Iscriviti per ricevere la nostra selezione privata.',
      scroll_cue: 'Scorri',
      lux_q: '"Eccellenza, autenticità, riservatezza — i tre pilastri di ogni nostra acquisizione."',
      lux_q_attr: '— GN Watches, Lugano',
    },
    catalog: {
      title: 'La Collezione',
      subtitle: 'Una selezione curata di orologi di lusso. Ogni pezzo è autenticato e verificato dai nostri esperti.',
      tab_in_stock: 'Disponibili',
      tab_on_request: 'Su Richiesta',
      search: 'Cerca per marca, modello, referenza',
      brand_all: 'Tutte le marche',
      min_price: 'Prezzo min',
      max_price: 'Prezzo max',
      condition: 'Condizione',
      condition_any: 'Qualsiasi',
      condition_new: 'Nuovo',
      condition_unworn: 'Mai indossato',
      condition_excellent: 'Eccellente',
      condition_good: 'Buono',
      reset: 'Azzera filtri',
      no_results: 'Nessun orologio corrisponde ai criteri di ricerca.',
      view_details: 'Scopri',
    },
    watch: {
      reference: 'Referenza',
      year: 'Anno',
      condition: 'Condizione',
      movement: 'Movimento',
      case_material: 'Cassa',
      case_size: 'Diametro',
      dial: 'Quadrante',
      box: 'Scatola',
      papers: 'Documenti',
      yes: 'Sì',
      no: 'No',
      buy: 'Acquista ora',
      inquire: 'Richiedi informazioni',
      sold: 'Venduto',
      description: 'Descrizione',
      specs: 'Specifiche',
      price_on_request: 'Prezzo su Richiesta',
      on_request_note: 'Questo pezzo è disponibile esclusivamente su richiesta. Contattaci per dettagli, prezzo e visione privata.',
    },
    sell: {
      title: 'Vendi il tuo Orologio',
      subtitle: 'Inviaci i dettagli del tuo segnatempo. Riceverai una valutazione discreta e professionale entro 48 ore.',
      name: 'Nome e cognome',
      email: 'Email',
      phone: 'Telefono',
      brand: 'Marca',
      model: 'Modello',
      year: 'Anno',
      condition: 'Condizione',
      price: 'Aspettativa di prezzo (EUR)',
      description: 'Descrizione dettagliata',
      has_box: 'Scatola originale',
      has_papers: 'Documenti / Garanzia',
      photos: 'Foto dell\'orologio',
      upload_t: 'Trascina qui le foto o clicca per selezionare',
      upload_b: 'JPG · PNG · WEBP · max 5 MB · fino a 8 foto',
      submit: 'Invia richiesta',
      success: 'Richiesta inviata. Ti contatteremo entro 48 ore.',
      error: 'Errore nell\'invio. Riprova.',
    },
    about: {
      eyebrow: 'About Us',
      title: 'Chi Siamo',
      story_t: 'La Nostra Storia',
      story_b1: 'GN Watches è nata con una visione chiara: ridefinire il commercio di orologi di lusso attraverso discrezione, fiducia e portata internazionale. Con base tra Lugano, Dubai e Monte Carlo, mettiamo in contatto collezionisti, investitori e appassionati con alcuni dei segnatempo più iconici al mondo.',
      story_b2: 'Più che un watch broker, GN Watches opera come una rete curata dove l\'artigianato senza tempo incontra l\'opportunità moderna. La nostra missione è offrire accesso a orologi eccezionali attraverso un approccio personalizzato e fondato sulle relazioni.',
      approach_t: 'Il Nostro Approccio',
      approach_b1: 'Combiniamo brokeraggio privato, inventario selezionato e una rete internazionale di partner per offrire soluzioni su misura ai clienti più esigenti. Adottando un modello asset-light, siamo in grado di fornire flessibilità, esclusività e accesso oltre i limiti tradizionali dello stock.',
      approach_b2: 'Ogni orologio rappresenta più di un prodotto — è patrimonio, identità e valore a lungo termine. In GN Watches, crediamo che il vero lusso si costruisca su fiducia, competenza e visione senza tempo.',
    },
    contact: {
      title: 'Contatti',
      subtitle: 'Per ogni richiesta, valutazione o private viewing, siamo a disposizione.',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefono',
      subject: 'Oggetto',
      message: 'Messaggio',
      send: 'Invia',
      success: 'Messaggio inviato. Ti risponderemo a breve.',
      offices: 'Sedi',
      phone_label: 'Telefono',
      email_label: 'Email',
    },
    partners: {
      title: 'Collabora con noi',
      subtitle: 'Trasforma il tuo negozio in profitto, senza rischio.',
      cta: 'Diventa partner',
      benefits_t: 'Vantaggi della partnership',
      benefits: ['Zero investimento', 'Più clienti qualificati', 'Meno stock immobilizzato', 'Immagine premium', 'Entrate aggiuntive'],
      how_t: 'Come funziona',
      how_steps: ['Selezione e gestione del cliente da parte di GN Watches', 'Esposizione presso il tuo negozio', 'Vendita gestita interamente da noi', 'Profitto condiviso con una fascia commissionale dedicata'],
    },
    checkout: {
      processing: 'Stiamo verificando il pagamento...',
      success_t: 'Pagamento confermato',
      success_b: 'Grazie per il tuo acquisto. Ti contatteremo a breve per organizzare la consegna del tuo orologio.',
      cancel_t: 'Pagamento annullato',
      cancel_b: 'L\'operazione è stata interrotta. Puoi riprovare o tornare alla collezione.',
      back_home: 'Torna alla home',
      back_catalog: 'Torna alla collezione',
      timeout: 'Verifica scaduta. Controlla l\'email per la conferma.',
      summary_t: 'Riepilogo Ordine',
      enter_email: 'Inserisci la tua email per procedere',
      email_note: 'Ti invieremo conferma d\'ordine e dettagli per il ritiro.',
      proceed_pay: 'Procedi al pagamento',
      total: 'Totale',
      go_back: 'Indietro',
      accepted: 'Accettiamo carta · Apple Pay · Google Pay',
      request_t: 'Richiesta informazioni',
      request_b: 'Compila il form per ricevere prezzo, disponibilità e fissare un appuntamento di visione privata.',
      request_send: 'Invia richiesta',
      request_success: 'Richiesta inviata. Ti ricontatteremo entro 48 ore.',
    },
    admin: {
      title: 'Area Riservata',
      login: 'Accedi',
      email: 'Email',
      password: 'Password',
      logout: 'Esci',
      dashboard: 'Dashboard',
      watches: 'Orologi',
      submissions: 'Richieste di vendita',
      contacts: 'Messaggi',
      add_watch: 'Aggiungi orologio',
      edit: 'Modifica',
      delete: 'Elimina',
      cancel: 'Annulla',
      save: 'Salva',
      confirm_delete: 'Confermi l\'eliminazione?',
      invalid_credentials: 'Credenziali non valide',
      featured: 'In evidenza',
      sold: 'Venduto',
      image_urls: 'URL immagini (una per riga)',
    },
    footer: { tagline: 'Swiss Quality · Timeless Value', rights: 'Tutti i diritti riservati.', terms: 'Termini & Condizioni', privacy: 'Privacy Policy', cookies: 'Cookie Policy', follow_us: 'Seguici', offices: 'Sedi', legal: 'Termini & Condizioni', network: 'Network', contact_h: 'Contatti', country_ch: 'Svizzera', piece_one: 'pezzo', piece_other: 'pezzi' },
    cookie: {
      title: 'Utilizziamo i cookie',
      body: 'Questo sito utilizza cookie tecnici e analitici per migliorare la tua esperienza. Continuando la navigazione accetti il loro utilizzo.',
      accept: 'Accetta',
      decline: 'Rifiuta',
    },
  },
  en: {
    nav: { home: 'Home', catalog: 'Collection', about: 'About Us', locations: 'Locations', sell: 'Sell Your Watch', partners: 'Partners', contact: 'Contact', admin: 'Admin' },
    home: {
      our_selection: 'Our Selection',
      eyebrow: 'High watchmaking maison',
      title_1: 'Timeless', title_2: 'by Nature',
      subtitle: 'Luxury watch trading, private brokerage and international network across Dubai, Switzerland and Monte Carlo.',
      cta_explore: 'Explore the collection',
      cta_sell: 'Sell your watch',
      featured: 'Featured pieces',
      vision_eyebrow: 'Our vision',
      vision_title: 'A premium network. Selected clients.',
      vision_body: 'GN Watches is not limited to its own stock: it operates as a watch broker for visionary partners, offering variety, flexibility and access to exclusive opportunities worldwide.',
      model_eyebrow: 'Our model',
      model_title: 'Asset-light. Curated. Discreet.',
      model_body: 'Our clients access both the watches available at GN Watches and a selected network of pieces from our partners.',
      why_eyebrow: 'Why GN Watches',
      why_items: ['International sourcing', 'Off-market access', 'Client screening', 'Private brokerage', 'Absolute confidentiality', 'Established network'],
      where_eyebrow: 'Where we operate',
      where_title: 'Dubai · Switzerland · Monte Carlo',
      where_body: 'An established network of buyers and sellers, with the ambition to expand globally.',
      hub_hq: 'Headquarters', hub_me: 'Middle East Hub', hub_eu: 'European Hub',
      stat_hubs: 'Global Hubs', stat_pieces: 'Off-Market Pieces', stat_valuation: 'Valuation',
      featured_eyebrow: 'Featured', featured_title: 'Current Selection', featured_cta: 'View All',
      featured_empty: 'New pieces arriving soon. Join our private list to receive our curated selection.',
      scroll_cue: 'Scroll',
      lux_q: '"Excellence, authenticity, discretion — the three pillars of every acquisition we make."',
      lux_q_attr: '— GN Watches, Lugano',
    },
    catalog: {
      title: 'The Collection',
      subtitle: 'A curated selection of luxury watches. Every piece is authenticated and verified by our experts.',
      tab_in_stock: 'In Stock',
      tab_on_request: 'On Request',
      search: 'Search by brand, model, reference',
      brand_all: 'All brands',
      min_price: 'Min price',
      max_price: 'Max price',
      condition: 'Condition',
      condition_any: 'Any',
      condition_new: 'New',
      condition_unworn: 'Unworn',
      condition_excellent: 'Excellent',
      condition_good: 'Good',
      reset: 'Reset filters',
      no_results: 'No watches match your search.',
      view_details: 'Discover',
    },
    watch: {
      reference: 'Reference', year: 'Year', condition: 'Condition', movement: 'Movement',
      case_material: 'Case', case_size: 'Diameter', dial: 'Dial',
      box: 'Box', papers: 'Papers', yes: 'Yes', no: 'No',
      buy: 'Buy now', inquire: 'Request information', sold: 'Sold',
      description: 'Description', specs: 'Specifications',
      price_on_request: 'Price on Request',
      on_request_note: 'This piece is available exclusively on request. Contact us for details, price and private viewing.',
    },
    sell: {
      title: 'Sell Your Watch',
      subtitle: 'Send us the details of your timepiece. You\'ll receive a discreet, professional valuation within 48 hours.',
      name: 'Full name', email: 'Email', phone: 'Phone', brand: 'Brand', model: 'Model',
      year: 'Year', condition: 'Condition', price: 'Price expectation (EUR)',
      description: 'Detailed description', has_box: 'Original box', has_papers: 'Papers / Warranty',
      photos: 'Watch photos',
      upload_t: 'Drag photos here or click to select',
      upload_b: 'JPG · PNG · WEBP · max 5 MB · up to 8 photos',
      submit: 'Submit request', success: 'Request sent. We\'ll contact you within 48 hours.', error: 'Sending error. Please retry.',
    },
    about: {
      eyebrow: 'About Us', title: 'About Us',
      story_t: 'Our Story',
      story_b1: 'GN Watches was founded with a clear vision: to redefine luxury watch trading through discretion, trust, and international reach. Based between Lugano, Dubai, and Monte Carlo, we connect collectors, investors, and enthusiasts with some of the world\'s most iconic timepieces.',
      story_b2: 'More than a watch broker, GN Watches operates as a curated network where timeless craftsmanship meets modern opportunity. Our mission is to offer access to exceptional watches through a personalized and relationship-driven approach.',
      approach_t: 'Our Approach',
      approach_b1: 'We combine private brokerage, selected inventory, and an international partner network to deliver tailored solutions for demanding clients. By adopting an asset-light model, we are able to provide flexibility, exclusivity, and access beyond traditional stock limitations.',
      approach_b2: 'Every watch represents more than a product — it is heritage, identity, and long-term value. At GN Watches, we believe true luxury is built on trust, expertise, and timeless vision.',
    },
    contact: {
      title: 'Contact', subtitle: 'For any request, valuation or private viewing, we are at your disposal.',
      name: 'Name', email: 'Email', phone: 'Phone', subject: 'Subject', message: 'Message',
      send: 'Send', success: 'Message sent. We\'ll respond shortly.',
      offices: 'Offices', phone_label: 'Phone', email_label: 'Email',
    },
    partners: {
      title: 'Partner with us',
      subtitle: 'Turn your store into profit — without risk.',
      cta: 'Become a partner',
      benefits_t: 'Partnership benefits',
      benefits: ['Zero investment', 'More qualified clients', 'Less immobilized stock', 'Premium image', 'Additional revenue'],
      how_t: 'How it works',
      how_steps: ['Client selection and management by GN Watches', 'Display at your premises', 'Sale fully handled by us', 'Shared profit with a dedicated commission tier'],
    },
    checkout: {
      processing: 'Verifying payment...',
      success_t: 'Payment confirmed', success_b: 'Thank you for your purchase. We\'ll contact you shortly to arrange delivery of your watch.',
      cancel_t: 'Payment cancelled', cancel_b: 'The transaction was interrupted. You can retry or return to the collection.',
      back_home: 'Back to home', back_catalog: 'Back to collection',
      timeout: 'Verification timed out. Check your email for confirmation.',
      summary_t: 'Order Summary',
      enter_email: 'Enter your email to proceed',
      email_note: 'We\'ll send order confirmation and delivery details.',
      proceed_pay: 'Proceed to payment',
      total: 'Total',
      go_back: 'Back',
      accepted: 'We accept card · Apple Pay · Google Pay · PayPal',
      request_t: 'Information request',
      request_b: 'Fill the form to receive price, availability and book a private viewing.',
      request_send: 'Send request',
      request_success: 'Request sent. We\'ll get back to you within 48 hours.',
    },
    admin: {
      title: 'Restricted Area', login: 'Sign in', email: 'Email', password: 'Password', logout: 'Sign out',
      dashboard: 'Dashboard', watches: 'Watches', submissions: 'Sell requests', contacts: 'Messages',
      add_watch: 'Add watch', edit: 'Edit', delete: 'Delete', cancel: 'Cancel', save: 'Save',
      confirm_delete: 'Confirm deletion?', invalid_credentials: 'Invalid credentials',
      featured: 'Featured', sold: 'Sold', image_urls: 'Image URLs (one per line)',
    },
    footer: { tagline: 'Swiss Quality · Timeless Value', rights: 'All rights reserved.', terms: 'Terms & Conditions', privacy: 'Privacy Policy', cookies: 'Cookie Policy', follow_us: 'Follow Us', offices: 'Offices', legal: 'Terms & Conditions', network: 'Network', contact_h: 'Contact', country_ch: 'Switzerland', piece_one: 'piece', piece_other: 'pieces' },
    cookie: {
      title: 'We use cookies',
      body: 'This site uses technical and analytical cookies to improve your experience. By continuing to browse you accept their use.',
      accept: 'Accept',
      decline: 'Decline',
    },
  },
  de: {
    nav: { home: 'Home', catalog: 'Kollektion', about: 'Über uns', locations: 'Standorte', sell: 'Uhr verkaufen', partners: 'Partner', contact: 'Kontakt', admin: 'Admin' },
    home: {
      our_selection: 'Unsere Auswahl',
      eyebrow: 'Haute Horlogerie Maison',
      title_1: 'Timeless', title_2: 'by Nature',
      subtitle: 'Schweizer Handel mit Luxusuhren, privates Brokerage und internationales Netzwerk zwischen Dubai, der Schweiz und Monte Carlo.',
      cta_explore: 'Kollektion entdecken', cta_sell: 'Ihre Uhr verkaufen',
      featured: 'Ausgewählte Stücke',
      vision_eyebrow: 'Unsere Vision',
      vision_title: 'Ein Premium-Netzwerk. Ausgewählte Kunden.',
      vision_body: 'GN Watches beschränkt sich nicht auf den eigenen Bestand: Wir agieren als Uhrenbroker für visionäre Partner und bieten Vielfalt, Flexibilität und Zugang zu exklusiven Möglichkeiten weltweit.',
      model_eyebrow: 'Unser Modell', model_title: 'Asset-light. Kuratiert. Diskret.',
      model_body: 'Unsere Kunden erhalten Zugang sowohl zu den Uhren bei GN Watches als auch zu einem ausgewählten Netzwerk von Stücken unserer Partner.',
      why_eyebrow: 'Warum GN Watches',
      why_items: ['Internationale Beschaffung', 'Off-Market-Zugang', 'Kunden-Screening', 'Privates Brokerage', 'Absolute Diskretion', 'Etabliertes Netzwerk'],
      where_eyebrow: 'Wo wir tätig sind', where_title: 'Dubai · Schweiz · Monte Carlo',
      where_body: 'Ein etabliertes Netzwerk von Käufern und Verkäufern mit globalem Expansionsanspruch.',
      hub_hq: 'Hauptsitz', hub_me: 'Nahost-Hub', hub_eu: 'Europäischer Hub',
      stat_hubs: 'Globale Hubs', stat_pieces: 'Off-Market-Stücke', stat_valuation: 'Bewertung',
      featured_eyebrow: 'Ausgewählt', featured_title: 'Aktuelle Auswahl', featured_cta: 'Alle ansehen',
      featured_empty: 'Neue Stücke folgen in Kürze. Treten Sie unserer privaten Liste bei, um unsere kuratierte Auswahl zu erhalten.',
      scroll_cue: 'Scrollen',
      lux_q: '„Exzellenz, Authentizität, Diskretion — die drei Säulen jeder Akquisition."',
      lux_q_attr: '— GN Watches, Lugano',
    },
    catalog: {
      title: 'Die Kollektion',
      subtitle: 'Eine kuratierte Auswahl von Luxusuhren. Jedes Stück ist von unseren Experten authentifiziert.',
      tab_in_stock: 'Verfügbar',
      tab_on_request: 'Auf Anfrage',
      search: 'Suche nach Marke, Modell, Referenz', brand_all: 'Alle Marken',
      min_price: 'Min. Preis', max_price: 'Max. Preis',
      condition: 'Zustand', condition_any: 'Beliebig', condition_new: 'Neu',
      condition_unworn: 'Ungetragen', condition_excellent: 'Hervorragend', condition_good: 'Gut',
      reset: 'Filter zurücksetzen', no_results: 'Keine Uhren entsprechen Ihrer Suche.',
      view_details: 'Entdecken',
    },
    watch: {
      reference: 'Referenz', year: 'Jahr', condition: 'Zustand', movement: 'Uhrwerk',
      case_material: 'Gehäuse', case_size: 'Durchmesser', dial: 'Zifferblatt',
      box: 'Box', papers: 'Papiere', yes: 'Ja', no: 'Nein',
      buy: 'Jetzt kaufen', inquire: 'Informationen anfordern', sold: 'Verkauft',
      description: 'Beschreibung', specs: 'Spezifikationen',
      price_on_request: 'Preis auf Anfrage',
      on_request_note: 'Dieses Stück ist ausschließlich auf Anfrage erhältlich. Kontaktieren Sie uns für Details, Preis und private Besichtigung.',
    },
    sell: {
      title: 'Verkaufen Sie Ihre Uhr',
      subtitle: 'Senden Sie uns die Details Ihres Zeitmessers. Sie erhalten innerhalb von 48 Stunden eine diskrete, professionelle Bewertung.',
      name: 'Vollständiger Name', email: 'E-Mail', phone: 'Telefon', brand: 'Marke', model: 'Modell',
      year: 'Jahr', condition: 'Zustand', price: 'Preisvorstellung (EUR)',
      description: 'Detaillierte Beschreibung', has_box: 'Originalbox', has_papers: 'Papiere / Garantie',
      photos: 'Fotos der Uhr',
      upload_t: 'Fotos hierher ziehen oder klicken zum Auswählen',
      upload_b: 'JPG · PNG · WEBP · max 5 MB · bis zu 8 Fotos',
      submit: 'Anfrage senden', success: 'Anfrage gesendet. Wir melden uns innerhalb von 48 Stunden.', error: 'Sendefehler. Bitte erneut versuchen.',
    },
    about: {
      eyebrow: 'Über uns', title: 'Über uns',
      story_t: 'Unsere Geschichte',
      story_b1: 'GN Watches wurde mit einer klaren Vision gegründet: den Handel mit Luxusuhren durch Diskretion, Vertrauen und internationale Reichweite neu zu definieren. Mit Standorten in Lugano, Dubai und Monte Carlo verbinden wir Sammler, Investoren und Enthusiasten mit einigen der ikonischsten Zeitmesser der Welt.',
      story_b2: 'GN Watches ist mehr als ein Uhrenbroker — wir sind ein kuratiertes Netzwerk, in dem zeitlose Handwerkskunst auf moderne Möglichkeiten trifft. Unsere Mission ist es, Zugang zu außergewöhnlichen Uhren durch einen persönlichen, beziehungsorientierten Ansatz zu bieten.',
      approach_t: 'Unser Ansatz',
      approach_b1: 'Wir kombinieren privates Brokerage, ausgewähltes Inventar und ein intensatz',
      approach_b1: 'Wir kombinieren privates Brokerage, ausgewähltes Inventar und ein internationales Partnernetzwerk, um maßgeschneiderte Lösungen für anspruchsvolle Kunden zu liefern. Durch unser Asset-light-Modell bieten wir Flexibilität, Exklusivität und Zugang jenseits traditioneller Bestandsgrenzen.',
      approach_b2: 'Jede Uhr ist mehr als ein Produkt — sie ist Erbe, Identität und langfristiger Wert. Bei GN Watches glauben wir, dass wahrer Luxus auf Vertrauen, Expertise und zeitloser Vision aufgebaut wird.',
    },
    contact: {
      title: 'Kontakt', subtitle: 'Für jede Anfrage, Bewertung oder private Besichtigung stehen wir zur Verfügung.',
      name: 'Name', email: 'E-Mail', phone: 'Telefon', subject: 'Betreff', message: 'Nachricht',
      send: 'Senden', success: 'Nachricht gesendet. Wir antworten in Kürze.',
      offices: 'Standorte', phone_label: 'Telefon', email_label: 'E-Mail',
    },
    partners: {
      title: 'Werden Sie Partner',
      subtitle: 'Verwandeln Sie Ihr Geschäft in Profit — ohne Risiko.',
      cta: 'Partner werden',
      benefits_t: 'Vorteile der Partnerschaft',
      benefits: ['Keine Investition', 'Mehr qualifizierte Kunden', 'Weniger gebundener Bestand', 'Premium-Image', 'Zusätzliche Einnahmen'],
      how_t: 'So funktioniert es',
      how_steps: ['Kundenauswahl und Management durch GN Watches', 'Präsentation in Ihren Räumlichkeiten', 'Verkauf vollständig durch uns abgewickelt', 'Gewinnbeteiligung mit dedizierter Provisionsstufe'],
    },
    checkout: {
      processing: 'Zahlung wird überprüft...',
      success_t: 'Zahlung bestätigt', success_b: 'Vielen Dank für Ihren Kauf. Wir melden uns in Kürze zur Lieferung Ihrer Uhr.',
      cancel_t: 'Zahlung abgebrochen', cancel_b: 'Die Transaktion wurde unterbrochen. Sie können es erneut versuchen oder zur Kollektion zurückkehren.',
      back_home: 'Zur Startseite', back_catalog: 'Zur Kollektion',
      timeout: 'Überprüfung abgelaufen. Prüfen Sie Ihre E-Mail.',
      summary_t: 'Bestellübersicht',
      enter_email: 'E-Mail eingeben, um fortzufahren',
      email_note: 'Wir senden Bestellbestätigung und Lieferdetails.',
      proceed_pay: 'Zur Zahlung',
      total: 'Gesamt',
      go_back: 'Zurück',
      accepted: 'Wir akzeptieren Karte · Apple Pay · Google Pay',
      request_t: 'Informationsanfrage',
      request_b: 'Füllen Sie das Formular aus, um Preis, Verfügbarkeit zu erhalten und eine private Besichtigung zu buchen.',
      request_send: 'Anfrage senden',
      request_success: 'Anfrage gesendet. Wir melden uns innerhalb von 48 Stunden.',
    },
    admin: {
      title: 'Geschützter Bereich', login: 'Anmelden', email: 'E-Mail', password: 'Passwort', logout: 'Abmelden',
      dashboard: 'Dashboard', watches: 'Uhren', submissions: 'Verkaufsanfragen', contacts: 'Nachrichten',
      add_watch: 'Uhr hinzufügen', edit: 'Bearbeiten', delete: 'Löschen', cancel: 'Abbrechen', save: 'Speichern',
      confirm_delete: 'Löschen bestätigen?', invalid_credentials: 'Ungültige Anmeldedaten',
      featured: 'Hervorgehoben', sold: 'Verkauft', image_urls: 'Bild-URLs (eine pro Zeile)',
    },
    footer: { tagline: 'Swiss Quality · Timeless Value', rights: 'Alle Rechte vorbehalten.', terms: 'AGB', privacy: 'Datenschutz', cookies: 'Cookie-Richtlinie', follow_us: 'Folgen Sie uns', offices: 'Standorte', legal: 'AGB', network: 'Netzwerk', contact_h: 'Kontakt', country_ch: 'Schweiz', piece_one: 'Stück', piece_other: 'Stücke' },
    cookie: {
      title: 'Wir verwenden Cookies',
      body: 'Diese Website verwendet technische und analytische Cookies, um Ihre Erfahrung zu verbessern. Durch die weitere Nutzung stimmen Sie deren Verwendung zu.',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
    },
  },
  fr: {
    nav: { home: 'Accueil', catalog: 'Collection', about: 'À propos', locations: 'Lieux', sell: 'Vendez votre montre', partners: 'Partenaires', contact: 'Contact', admin: 'Admin' },
    home: {
      our_selection: 'Notre Sélection',
      eyebrow: 'Maison de haute horlogerie',
      title_1: 'Timeless', title_2: 'by Nature',
      subtitle: 'Négoce de montres de luxe, courtage privé et réseau international entre Dubaï, Suisse et Monte-Carlo.',
      cta_explore: 'Découvrir la collection', cta_sell: 'Vendre votre montre',
      featured: 'Pièces phares',
      vision_eyebrow: 'Notre vision', vision_title: 'Un réseau premium. Clients sélectionnés.',
      vision_body: 'GN Watches ne se limite pas à son propre stock : nous opérons en tant que watch broker pour des partenaires visionnaires, offrant variété, flexibilité et accès à des opportunités exclusives dans le monde entier.',
      model_eyebrow: 'Notre modèle', model_title: 'Asset-light. Sélectionné. Discret.',
      model_body: 'Nos clients accèdent aussi bien aux montres disponibles chez GN Watches qu\'à un réseau sélectionné de pièces de nos partenaires.',
      why_eyebrow: 'Pourquoi GN Watches',
      why_items: ['Sourcing international', 'Accès off-market', 'Sélection des clients', 'Courtage privé', 'Confidentialité absolue', 'Réseau établi'],
      where_eyebrow: 'Où nous opérons', where_title: 'Dubaï · Suisse · Monte-Carlo',
      where_body: 'Un réseau établi d\'acheteurs et de vendeurs, avec l\'ambition de s\'étendre globalement.',
      hub_hq: 'Siège', hub_me: 'Hub Moyen-Orient', hub_eu: 'Hub Européen',
      stat_hubs: 'Hubs Mondiaux', stat_pieces: 'Pièces Off-Market', stat_valuation: 'Évaluation',
      featured_eyebrow: 'En vedette', featured_title: 'Sélection actuelle', featured_cta: 'Tout voir',
      featured_empty: 'Nouvelles pièces bientôt disponibles. Rejoignez notre liste privée pour recevoir notre sélection.',
      scroll_cue: 'Défiler',
      lux_q: '« Excellence, authenticité, discrétion — les trois piliers de chaque acquisition. »',
      lux_q_attr: '— GN Watches, Lugano',
    },
    catalog: {
      title: 'La Collection', subtitle: 'Une sélection curatée de montres de luxe. Chaque pièce est authentifiée par nos experts.',
      tab_in_stock: 'En Stock',
      tab_on_request: 'Sur Demande',
      search: 'Rechercher par marque, modèle, référence', brand_all: 'Toutes les marques',
      min_price: 'Prix min', max_price: 'Prix max',
      condition: 'État', condition_any: 'Tous', condition_new: 'Neuf',
      condition_unworn: 'Jamais porté', condition_excellent: 'Excellent', condition_good: 'Bon',
      reset: 'Réinitialiser les filtres', no_results: 'Aucune montre ne correspond à votre recherche.',
      view_details: 'Découvrir',
    },
    watch: {
      reference: 'Référence', year: 'Année', condition: 'État', movement: 'Mouvement',
      case_material: 'Boîtier', case_size: 'Diamètre', dial: 'Cadran',
      box: 'Boîte', papers: 'Papiers', yes: 'Oui', no: 'Non',
      buy: 'Acheter maintenant', inquire: 'Demander des informations', sold: 'Vendu',
      description: 'Description', specs: 'Spécifications',
      price_on_request: 'Prix sur Demande',
      on_request_note: 'Cette pièce est disponible exclusivement sur demande. Contactez-nous pour les détails, le prix et une visite privée.',
    },
    sell: {
      title: 'Vendez votre montre',
      subtitle: 'Envoyez-nous les détails de votre garde-temps. Vous recevrez une évaluation discrète et professionnelle sous 48 heures.',
      name: 'Nom complet', email: 'Email', phone: 'Téléphone', brand: 'Marque', model: 'Modèle',
      year: 'Année', condition: 'État', price: 'Prix souhaité (EUR)',
      description: 'Description détaillée', has_box: 'Boîte d\'origine', has_papers: 'Papiers / Garantie',
      photos: 'Photos de la montre',
      upload_t: 'Glissez les photos ici ou cliquez pour sélectionner',
      upload_b: 'JPG · PNG · WEBP · max 5 Mo · jusqu\'à 8 photos',
      submit: 'Envoyer la demande', success: 'Demande envoyée. Nous vous contacterons sous 48 heures.', error: 'Erreur d\'envoi. Réessayez.',
    },
    about: {
      eyebrow: 'À propos', title: 'À propos',
      story_t: 'Notre Histoire',
      story_b1: 'GN Watches a été fondée avec une vision claire : redéfinir le commerce des montres de luxe par la discrétion, la confiance et une portée internationale. Basée entre Lugano, Dubaï et Monte-Carlo, nous mettons en relation collectionneurs, investisseurs et passionnés avec certains des garde-temps les plus iconiques au monde.',
      story_b2: 'Plus qu\'un watch broker, GN Watches opère comme un réseau curaté où l\'artisanat intemporel rencontre les opportunités modernes. Notre mission est d\'offrir l\'accès à des montres exceptionnelles à travers une approche personnalisée et fondée sur la relation.',
      approach_t: 'Notre Approche',
      approach_b1: 'Nous combinons courtage privé, inventaire sélectionné et réseau international de partenaires pour offrir des solutions sur mesure aux clients exigeants. En adoptant un modèle asset-light, nous offrons flexibilité, exclusivité et accès au-delà des limites traditionnelles du stock.',
      approach_b2: 'Chaque montre représente plus qu\'un produit — elle est héritage, identité et valeur à long terme. Chez GN Watches, nous croyons que le vrai luxe se construit sur la confiance, l\'expertise et une vision intemporelle.',
    },
    contact: {
      title: 'Contact', subtitle: 'Pour toute demande, évaluation ou visite privée, nous sommes à votre disposition.',
      name: 'Nom', email: 'Email', phone: 'Téléphone', subject: 'Sujet', message: 'Message',
      send: 'Envoyer', success: 'Message envoyé. Nous répondrons sous peu.',
      offices: 'Bureaux', phone_label: 'Téléphone', email_label: 'Email',
    },
    partners: {
      title: 'Devenez partenaire',
      subtitle: 'Transformez votre boutique en profit — sans risque.',
      cta: 'Devenir partenaire',
      benefits_t: 'Avantages du partenariat',
      benefits: ['Zéro investissement', 'Plus de clients qualifiés', 'Moins de stock immobilisé', 'Image premium', 'Revenus supplémentaires'],
      how_t: 'Comment ça marche',
      how_steps: ['Sélection et gestion du client par GN Watches', 'Exposition dans vos locaux', 'Vente entièrement gérée par nous', 'Profit partagé avec une commission dédiée'],
    },
    checkout: {
      processing: 'Vérification du paiement...',
      success_t: 'Paiement confirmé', success_b: 'Merci pour votre achat. Nous vous contacterons sous peu pour organiser la livraison.',
      cancel_t: 'Paiement annulé', cancel_b: 'La transaction a été interrompue. Vous pouvez réessayer ou revenir à la collection.',
      back_home: 'Retour à l\'accueil', back_catalog: 'Retour à la collection',
      timeout: 'Vérification expirée. Consultez votre email.',
      summary_t: 'Récapitulatif de commande',
      enter_email: 'Entrez votre email pour continuer',
      email_note: 'Nous enverrons la confirmation et les détails de livraison.',
      proceed_pay: 'Procéder au paiement',
      total: 'Total',
      go_back: 'Retour',
      accepted: 'Nous acceptons carte · Apple Pay · Google Pay',
      request_t: 'Demande d\'informations',
      request_b: 'Remplissez le formulaire pour recevoir prix, disponibilité et réserver une visite privée.',
      request_send: 'Envoyer la demande',
      request_success: 'Demande envoyée. Nous vous recontacterons sous 48 heures.',
    },
    admin: {
      title: 'Espace réservé', login: 'Connexion', email: 'Email', password: 'Mot de passe', logout: 'Déconnexion',
      dashboard: 'Tableau de bord', watches: 'Montres', submissions: 'Demandes de vente', contacts: 'Messages',
      add_watch: 'Ajouter une montre', edit: 'Modifier', delete: 'Supprimer', cancel: 'Annuler', save: 'Enregistrer',
      confirm_delete: 'Confirmer la suppression ?', invalid_credentials: 'Identifiants invalides',
      featured: 'En vedette', sold: 'Vendu', image_urls: 'URLs d\'images (une par ligne)',
    },
    footer: { tagline: 'Swiss Quality · Timeless Value', rights: 'Tous droits réservés.', terms: 'CGV', privacy: 'Politique de confidentialité', cookies: 'Politique des cookies', follow_us: 'Suivez-nous', offices: 'Bureaux', legal: 'CGV', network: 'Réseau', contact_h: 'Contact', country_ch: 'Suisse', piece_one: 'pièce', piece_other: 'pièces' },
    cookie: {
      title: 'Nous utilisons des cookies',
      body: 'Ce site utilise des cookies techniques et analytiques pour améliorer votre expérience. En continuant la navigation vous acceptez leur utilisation.',
      accept: 'Accepter',
      decline: 'Refuser',
    },
  },
  es: {
    nav: { home: 'Inicio', catalog: 'Colección', about: 'Sobre Nosotros', locations: 'Sedes', sell: 'Vende tu reloj', partners: 'Socios', contact: 'Contacto', admin: 'Admin' },
    home: {
      our_selection: 'Nuestra Selección',
      eyebrow: 'Maison de alta relojería',
      title_1: 'Timeless', title_2: 'by Nature',
      subtitle: 'Compraventa de relojes de lujo, intermediación privada y red internacional entre Dubái, Suiza y Montecarlo.',
      cta_explore: 'Descubre la colección',
      cta_sell: 'Vende tu reloj',
      featured: 'Piezas destacadas',
      vision_eyebrow: 'Nuestra visión',
      vision_title: 'Una red premium. Clientes seleccionados.',
      vision_body: 'GN Watches no se limita a su propio stock: opera como intermediario para socios visionarios, ofreciendo variedad, flexibilidad y acceso a oportunidades exclusivas en todo el mundo.',
      model_eyebrow: 'Nuestro modelo',
      model_title: 'Asset-light. Curado. Discreto.',
      model_body: 'Nuestros clientes acceden tanto a los relojes disponibles en GN Watches como a una red seleccionada de piezas de nuestros socios.',
      why_eyebrow: 'Por qué GN Watches',
      why_items: ['Sourcing internacional', 'Acceso off-market', 'Selección de clientes', 'Intermediación privada', 'Confidencialidad absoluta', 'Red consolidada'],
      where_eyebrow: 'Dónde operamos',
      where_title: 'Dubái · Suiza · Montecarlo',
      where_body: 'Una red consolidada de compradores y vendedores, con la ambición de expandirnos globalmente.',
      hub_hq: 'Sede central', hub_me: 'Hub Oriente Medio', hub_eu: 'Hub Europeo',
      stat_hubs: 'Hubs Globales', stat_pieces: 'Piezas Off-Market', stat_valuation: 'Valoración',
      featured_eyebrow: 'Destacados', featured_title: 'Selección actual', featured_cta: 'Ver todo',
      featured_empty: 'Próximamente nuevas piezas. Únete a nuestra lista privada para recibir nuestra selección.',
      scroll_cue: 'Desliza',
      lux_q: '«Excelencia, autenticidad, discreción — los tres pilares de cada adquisición.»',
      lux_q_attr: '— GN Watches, Lugano',
    },
    catalog: {
      title: 'La Colección',
      subtitle: 'Una selección curada de relojes de lujo. Cada pieza está autenticada y verificada por nuestros expertos.',
      tab_in_stock: 'En Stock',
      tab_on_request: 'Bajo Petición',
      search: 'Buscar por marca, modelo, referencia',
      brand_all: 'Todas las marcas',
      min_price: 'Precio mín',
      max_price: 'Precio máx',
      condition: 'Estado',
      condition_any: 'Cualquiera',
      condition_new: 'Nuevo',
      condition_unworn: 'Sin usar',
      condition_excellent: 'Excelente',
      condition_good: 'Bueno',
      reset: 'Restablecer filtros',
      no_results: 'Ningún reloj coincide con tu búsqueda.',
      view_details: 'Descubrir',
    },
    watch: {
      reference: 'Referencia', year: 'Año', condition: 'Estado', movement: 'Movimiento',
      case_material: 'Caja', case_size: 'Diámetro', dial: 'Esfera',
      box: 'Caja', papers: 'Documentos', yes: 'Sí', no: 'No',
      buy: 'Comprar ahora', inquire: 'Solicitar información', sold: 'Vendido',
      description: 'Descripción', specs: 'Especificaciones',
      price_on_request: 'Precio a Consultar',
      on_request_note: 'Esta pieza está disponible exclusivamente bajo petición. Contáctanos para detalles, precio y visita privada.',
    },
    sell: {
      title: 'Vende tu reloj',
      subtitle: 'Envíanos los detalles de tu pieza. Recibirás una valoración profesional y discreta en 48 horas.',
      name: 'Nombre completo', email: 'Email', phone: 'Teléfono', brand: 'Marca', model: 'Modelo',
      year: 'Año', condition: 'Estado', price: 'Precio esperado (EUR)',
      description: 'Descripción detallada', has_box: 'Caja original', has_papers: 'Documentos / Garantía',
      photos: 'Fotos del reloj',
      upload_t: 'Arrastra las fotos aquí o haz clic para seleccionar',
      upload_b: 'JPG · PNG · WEBP · máx 5 MB · hasta 8 fotos',
      submit: 'Enviar solicitud', success: 'Solicitud enviada. Te contactaremos en 48 horas.', error: 'Error al enviar. Por favor reintenta.',
    },
    about: {
      eyebrow: 'Sobre nosotros', title: 'Sobre Nosotros',
      story_t: 'Nuestra Historia',
      story_b1: 'GN Watches nació con una visión clara: redefinir la compraventa de relojes de lujo a través de la discreción, la confianza y la proyección internacional. Con sede entre Lugano, Dubái y Montecarlo, conectamos coleccionistas, inversores y aficionados con algunos de los relojes más icónicos del mundo.',
      story_b2: 'Más que un intermediario, GN Watches opera como una red curada donde la artesanía intemporal se encuentra con la oportunidad moderna. Nuestra misión es ofrecer acceso a relojes excepcionales con un enfoque personalizado y basado en relaciones.',
      approach_t: 'Nuestro Enfoque',
      approach_b1: 'Combinamos intermediación privada, inventario seleccionado y una red internacional de socios para ofrecer soluciones a medida a clientes exigentes. Adoptando un modelo asset-light, podemos ofrecer flexibilidad, exclusividad y acceso más allá de los límites del stock tradicional.',
      approach_b2: 'Cada reloj representa más que un producto — es herencia, identidad y valor a largo plazo. En GN Watches creemos que el verdadero lujo se construye sobre la confianza, la experiencia y una visión atemporal.',
    },
    contact: {
      title: 'Contacto', subtitle: 'Para cualquier solicitud, valoración o visita privada estamos a tu disposición.',
      name: 'Nombre', email: 'Email', phone: 'Teléfono', subject: 'Asunto', message: 'Mensaje',
      send: 'Enviar', success: 'Mensaje enviado. Responderemos en breve.',
      offices: 'Sedes', phone_label: 'Teléfono', email_label: 'Email',
    },
    partners: {
      title: 'Colabora con nosotros',
      subtitle: 'Convierte tu tienda en beneficio — sin riesgos.',
      cta: 'Conviértete en socio',
      benefits_t: 'Ventajas de la colaboración',
      benefits: ['Inversión cero', 'Clientes más cualificados', 'Menos stock inmovilizado', 'Imagen premium', 'Ingresos adicionales'],
      how_t: 'Cómo funciona',
      how_steps: ['Selección y gestión de clientes por parte de GN Watches', 'Exposición en tus instalaciones', 'Venta gestionada íntegramente por nosotros', 'Beneficio compartido con un nivel de comisión dedicado'],
    },
    checkout: {
      processing: 'Verificando el pago...',
      success_t: 'Pago confirmado', success_b: 'Gracias por tu compra. Te contactaremos en breve para coordinar la entrega de tu reloj.',
      cancel_t: 'Pago cancelado', cancel_b: 'La transacción se interrumpió. Puedes reintentar o volver a la colección.',
      back_home: 'Volver al inicio', back_catalog: 'Volver a la colección',
      timeout: 'Tiempo de verificación agotado. Comprueba tu email para la confirmación.',
      summary_t: 'Resumen del pedido',
      enter_email: 'Introduce tu email para continuar',
      email_note: 'Te enviaremos la confirmación del pedido y los detalles de entrega.',
      proceed_pay: 'Proceder al pago',
      total: 'Total',
      go_back: 'Atrás',
      accepted: 'Aceptamos tarjeta · Apple Pay · Google Pay · PayPal',
      request_t: 'Solicitud de información',
      request_b: 'Rellena el formulario para recibir precio, disponibilidad y reservar una visita privada.',
      request_send: 'Enviar solicitud',
      request_success: 'Solicitud enviada. Te responderemos en 48 horas.',
    },
    admin: {
      title: 'Área restringida', login: 'Acceder', email: 'Email', password: 'Contraseña', logout: 'Salir',
      dashboard: 'Dashboard', watches: 'Relojes', submissions: 'Solicitudes de venta', contacts: 'Mensajes',
      add_watch: 'Añadir reloj', edit: 'Editar', delete: 'Eliminar', cancel: 'Cancelar', save: 'Guardar',
      confirm_delete: '¿Confirmar eliminación?', invalid_credentials: 'Credenciales no válidas',
      featured: 'Destacado', sold: 'Vendido', image_urls: 'URLs de imagen (una por línea)',
    },
    footer: { tagline: 'Swiss Quality · Timeless Value', rights: 'Todos los derechos reservados.', terms: 'Términos y Condiciones', privacy: 'Política de Privacidad', cookies: 'Política de Cookies', follow_us: 'Síguenos', offices: 'Sedes', legal: 'Términos y Condiciones', network: 'Red', contact_h: 'Contacto', country_ch: 'Suiza', piece_one: 'pieza', piece_other: 'piezas' },
    cookie: {
      title: 'Utilizamos cookies',
      body: 'Este sitio utiliza cookies técnicas y analíticas para mejorar tu experiencia. Al continuar navegando aceptas su uso.',
      accept: 'Aceptar',
      decline: 'Rechazar',
    },
  },

  ar: {
    nav: { home: 'الرئيسية', catalog: 'المجموعة', about: 'من نحن', locations: 'المواقع', sell: 'بيع ساعتك', partners: 'الشركاء', contact: 'اتصل بنا', admin: 'الإدارة' },
    home: {
      our_selection: 'مجموعتنا',
      eyebrow: 'دار صناعة الساعات الراقية',
      title_1: 'Timeless', title_2: 'by Nature',
      subtitle: 'اكتشف ساعات فاخرة نادرة وحصرية، مختارة لعملاء يقدّرون الأصالة والتكتم والتصميم الخالد.',
      cta_explore: 'استكشف المجموعة', cta_sell: 'بع ساعتك',
      featured: 'القطع المميزة',
      vision_eyebrow: 'رؤيتنا', vision_title: 'شبكة متميزة. عملاء مختارون.',
      vision_body: 'لا تقتصر GN Watches على مخزونها الخاص: نعمل كوسيط ساعات لشركاء أصحاب رؤى، نقدم التنوع والمرونة والوصول إلى فرص حصرية حول العالم.',
      model_eyebrow: 'نموذجنا', model_title: 'خفيف الأصول. منتقى. حصيف.',
      model_body: 'يصل عملاؤنا إلى الساعات المتوفرة لدى GN Watches وإلى شبكة مختارة من قطع شركائنا.',
      why_eyebrow: 'لماذا GN Watches',
      why_items: ['التوريد الدولي', 'الوصول خارج السوق', 'فرز العملاء', 'الوساطة الخاصة', 'سرية مطلقة', 'شبكة راسخة'],
      where_eyebrow: 'أين نعمل', where_title: 'دبي · سويسرا · موناكو',
      where_body: 'شبكة راسخة من المشترين والبائعين، مع طموح التوسع عالمياً.',
      hub_hq: 'المقر الرئيسي', hub_me: 'مركز الشرق الأوسط', hub_eu: 'المركز الأوروبي',
      stat_hubs: 'مراكز دولية', stat_pieces: 'قطع حصرية', stat_valuation: 'التقييم',
      featured_eyebrow: 'مختار', featured_title: 'الاختيار الحالي', featured_cta: 'عرض الكل',
      featured_empty: 'قطع جديدة قادمة قريباً. انضم إلى قائمتنا الخاصة لتلقي اختيارنا الحصري.',
      scroll_cue: 'مرّر',
      lux_q: '«التميز، الأصالة، التكتم — الركائز الثلاث لكل اقتناء.»',
      lux_q_attr: '— GN Watches، لوغانو',
    },
    catalog: {
      title: 'المجموعة', subtitle: 'مجموعة منتقاة من الساعات الفاخرة. كل قطعة موثقة من خبرائنا.',
      tab_in_stock: 'متوفر',
      tab_on_request: 'عند الطلب',
      search: 'ابحث بالعلامة، الموديل، المرجع', brand_all: 'كل العلامات',
      min_price: 'أدنى سعر', max_price: 'أعلى سعر',
      condition: 'الحالة', condition_any: 'أي', condition_new: 'جديد',
      condition_unworn: 'لم تُلبس', condition_excellent: 'ممتاز', condition_good: 'جيد',
      reset: 'إعادة ضبط', no_results: 'لا توجد ساعات تطابق بحثك.',
      view_details: 'اكتشف',
    },
    watch: {
      reference: 'المرجع', year: 'السنة', condition: 'الحالة', movement: 'الحركة',
      case_material: 'العلبة', case_size: 'القطر', dial: 'الميناء',
      box: 'العلبة', papers: 'الأوراق', yes: 'نعم', no: 'لا',
      buy: 'اشترِ الآن', inquire: 'اطلب معلومات', sold: 'مباع',
      description: 'الوصف', specs: 'المواصفات',
      price_on_request: 'السعر عند الطلب',
      on_request_note: 'هذه القطعة متوفرة حصرياً عند الطلب. تواصل معنا للتفاصيل والسعر والمعاينة الخاصة.',
    },
    sell: {
      title: 'بع ساعتك',
      subtitle: 'أرسل لنا تفاصيل ساعتك. ستتلقى تقييماً مهنياً وحصيفاً خلال 48 ساعة.',
      name: 'الاسم الكامل', email: 'البريد الإلكتروني', phone: 'الهاتف', brand: 'العلامة', model: 'الموديل',
      year: 'السنة', condition: 'الحالة', price: 'السعر المتوقع (يورو)',
      description: 'وصف مفصل', has_box: 'العلبة الأصلية', has_papers: 'الأوراق / الضمان',
      photos: 'صور الساعة',
      upload_t: 'اسحب الصور هنا أو انقر للاختيار',
      upload_b: 'JPG · PNG · WEBP · بحد أقصى 5 ميغابايت · حتى 8 صور',
      submit: 'إرسال الطلب', success: 'تم إرسال الطلب. سنتواصل معك خلال 48 ساعة.', error: 'خطأ في الإرسال. حاول مجدداً.',
    },
    about: {
      eyebrow: 'من نحن', title: 'من نحن',
      story_t: 'قصتنا',
      story_b1: 'تأسست GN Watches برؤية واضحة: إعادة تعريف تجارة الساعات الفاخرة من خلال السرية والثقة والانتشار الدولي. تتمركز بين لوغانو ودبي وموناكو، ونصل بين هواة الجمع والمستثمرين والمحبين مع بعض من أكثر الساعات شهرة في العالم.',
      story_b2: 'أكثر من مجرد وسيط ساعات، تعمل GN Watches كشبكة منتقاة حيث تلتقي الحرفية الخالدة بالفرصة الحديثة. مهمتنا هي تقديم وصول إلى ساعات استثنائية من خلال نهج شخصي قائم على العلاقات.',
      approach_t: 'نهجنا',
      approach_b1: 'نجمع بين الوساطة الخاصة والمخزون المختار وشبكة شركاء دولية لتقديم حلول مخصصة للعملاء الأكثر تطلباً. باعتمادنا نموذجاً خفيف الأصول، نقدم المرونة والحصرية والوصول إلى ما هو أبعد من حدود المخزون التقليدية.',
      approach_b2: 'كل ساعة تمثل أكثر من مجرد منتج — إنها إرث وهوية وقيمة طويلة الأمد. في GN Watches، نؤمن أن الفخامة الحقيقية تُبنى على الثقة والخبرة والرؤية الخالدة.',
    },
    contact: {
      title: 'اتصل بنا', subtitle: 'لأي طلب أو تقييم أو معاينة خاصة، نحن في خدمتك.',
      name: 'الاسم', email: 'البريد الإلكتروني', phone: 'الهاتف', subject: 'الموضوع', message: 'الرسالة',
      send: 'إرسال', success: 'تم إرسال الرسالة. سنرد قريباً.',
      offices: 'المكاتب', phone_label: 'الهاتف', email_label: 'البريد الإلكتروني',
    },
    partners: {
      title: 'كن شريكاً',
      subtitle: 'حوّل متجرك إلى ربح — بلا مخاطر.',
      cta: 'انضم كشريك',
      benefits_t: 'مزايا الشراكة',
      benefits: ['صفر استثمار', 'عملاء مؤهلون أكثر', 'مخزون مجمد أقل', 'صورة فاخرة', 'إيرادات إضافية'],
      how_t: 'كيف يعمل',
      how_steps: ['اختيار وإدارة العميل من GN Watches', 'العرض في مقرك', 'البيع يدار بالكامل من قبلنا', 'ربح مشترك مع نسبة عمولة مخصصة'],
    },
    checkout: {
      processing: 'جارٍ التحقق من الدفع...',
      success_t: 'تم تأكيد الدفع', success_b: 'شكراً لشرائك. سنتواصل قريباً لترتيب التسليم.',
      cancel_t: 'تم إلغاء الدفع', cancel_b: 'تم إيقاف العملية. يمكنك المحاولة مجدداً أو العودة للمجموعة.',
      back_home: 'العودة للرئيسية', back_catalog: 'العودة للمجموعة',
      timeout: 'انتهت مهلة التحقق. تحقق من بريدك.',
      summary_t: 'ملخص الطلب',
      enter_email: 'أدخل بريدك الإلكتروني للمتابعة',
      email_note: 'سنرسل تأكيد الطلب وتفاصيل التسليم.',
      proceed_pay: 'المتابعة إلى الدفع',
      total: 'الإجمالي',
      go_back: 'رجوع',
      accepted: 'نقبل البطاقة · Apple Pay · Google Pay',
      request_t: 'طلب معلومات',
      request_b: 'املأ النموذج لتلقي السعر والتوفر وحجز معاينة خاصة.',
      request_send: 'إرسال الطلب',
      request_success: 'تم إرسال الطلب. سنتواصل معك خلال 48 ساعة.',
    },
    admin: {
      title: 'منطقة محظورة', login: 'دخول', email: 'البريد', password: 'كلمة السر', logout: 'خروج',
      dashboard: 'لوحة التحكم', watches: 'الساعات', submissions: 'طلبات البيع', contacts: 'الرسائل',
      add_watch: 'إضافة ساعة', edit: 'تعديل', delete: 'حذف', cancel: 'إلغاء', save: 'حفظ',
      confirm_delete: 'تأكيد الحذف؟', invalid_credentials: 'بيانات غير صحيحة',
      featured: 'مميز', sold: 'مباع', image_urls: 'روابط الصور (واحد بكل سطر)',
    },
    footer: { tagline: 'Swiss Quality · Timeless Value', rights: 'جميع الحقوق محفوظة.', terms: 'الشروط والأحكام', privacy: 'سياسة الخصوصية', cookies: 'سياسة ملفات تعريف الارتباط', follow_us: 'تابعنا', offices: 'المكاتب', legal: 'الشروط', network: 'الشبكة', contact_h: 'اتصل', country_ch: 'سويسرا', piece_one: 'قطعة', piece_other: 'قطع' },
    cookie: {
      title: 'نستخدم ملفات تعريف الارتباط',
      body: 'يستخدم هذا الموقع ملفات تعريف الارتباط التقنية والتحليلية لتحسين تجربتك. بمتابعة التصفح فإنك توافق على استخدامها.',
      accept: 'موافق',
      decline: 'رفض',
    },
  },
};
